(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brincatoys-collection-directory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bt-collection-directory')) {
    customElements.define('bt-collection-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.disclosure = this.querySelector('.bt-directory__disclosure');
        if (this.disclosure) {
          this.mobileQuery = window.matchMedia('(max-width: 749px)');
          this.syncDisclosure = () => {
            if (this.disclosure.dataset.userInteracted === 'true') return;
            this.disclosure.open = !this.mobileQuery.matches;
          };
          this.disclosure.querySelector(':scope > summary')?.addEventListener('click', () => {
            this.disclosure.dataset.userInteracted = 'true';
          }, { signal: this.events.signal });
          if (this.mobileQuery.addEventListener) {
            this.mobileQuery.addEventListener('change', this.syncDisclosure, { signal: this.events.signal });
          } else {
            this.mobileQuery.addListener(this.syncDisclosure);
          }
          this.syncDisclosure();
        }
        this.input = this.querySelector('input[type="search"]');
        if (!this.input) return;
        this.cards = [...this.querySelectorAll('[data-directory-card]')];
        this.clear = this.querySelector('.bt-directory__clear');
        this.status = this.querySelector('.bt-directory__results');
        this.empty = this.querySelector('.bt-directory__empty');
        this.productSearch = this.querySelector('.bt-directory__product-search');
        this.input.addEventListener('input', () => this.filter(), { signal: this.events.signal });
        this.clear.addEventListener('click', () => { this.input.value = ''; this.filter(); this.input.focus(); }, { signal: this.events.signal });
        this.querySelector('.bt-directory__tools').hidden = false;
        this.filter();
      }
      disconnectedCallback() {
        this.events?.abort();
        if (this.mobileQuery && !this.mobileQuery.removeEventListener) this.mobileQuery.removeListener(this.syncDisclosure);
        this.events = null;
      }
      normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
      filterItem(item, query, showAll = false) {
        const label = item.firstElementChild?.querySelector('.bt-directory__label');
        const matchesLabel = this.normalize(label?.textContent || '').includes(query);
        const children = item.querySelector(':scope > .bt-directory__children')?.children || [];
        let hasMatchingChild = false;
        for (const child of children) {
          if (this.filterItem(child, query, showAll || matchesLabel)) hasMatchingChild = true;
        }
        item.hidden = !(showAll || matchesLabel || hasMatchingChild);
        return !item.hidden;
      }
      filter() {
        const query = this.normalize(this.input.value);
        let count = 0;
        this.cards.forEach(card => {
          if (this.filterItem(card, query)) count++;
        });
        this.status.textContent = this.dataset.resultsLabel + ' ' + count;
        this.empty.hidden = count !== 0;
        if (count === 0 && this.productSearch) {
          const params = new URLSearchParams({ q: this.input.value.trim(), type: 'product' });
          this.productSearch.href = this.productSearch.dataset.searchUrl + '?' + params.toString();
        }
        this.clear.hidden = query === '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brincatoys-facets-style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brincatoys-facet-values')) {
  customElements.define('brincatoys-facet-values', class BrincatoysFacetValues extends HTMLElement {
    connectedCallback() {
      if (this.dataset.btReady === 'true') return;
      this.dataset.btReady = 'true';
      this.searchInput = this.querySelector('[data-bt-facet-search]');
      if (!this.searchInput) return;

      this.lastQuery = '';
      this.wasExpanded = false;
      this.addEventListener('input', (event) => {
        if (event.target !== this.searchInput) return;
        event.stopPropagation();
        this.applySearch();
      });

      this.observer = new MutationObserver(() => this.applySearch());
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    normalize(value) {
      return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    captureState() {
      return {
        query: this.searchInput?.value || '',
        expanded: this.lastQuery
          ? this.wasExpanded
          : Boolean(this.querySelector('show-more-button')?.classList.contains('hidden')),
      };
    }

    restoreState(state) {
      if (!state || !this.searchInput) return;
      this.searchInput.value = state.query;
      this.wasExpanded = state.expanded;
      // A restored query must not infer expansion from the new server markup.
      this.lastQuery = this.normalize(state.query);
      this.applySearch();
    }

    applySearch() {
      const query = this.normalize(this.searchInput.value);
      const items = [...this.querySelectorAll('[data-bt-facet-label]')];
      const showMore = this.querySelector('show-more-button');
      const emptyState = this.querySelector('[data-bt-facet-empty]');

      if (query && !this.lastQuery) {
        this.wasExpanded = showMore?.classList.contains('hidden') ?? false;
      }

      if (query) {
        let matches = 0;
        items.forEach((item) => {
          if (item.dataset.btCollapsed === 'true') item.classList.remove('hidden');
          const isMatch = this.normalize(item.dataset.btFacetLabel).includes(query);
          item.classList.toggle('bt-facet-search-hidden', !isMatch);
          if (isMatch) matches += 1;
        });
        showMore?.classList.add('bt-facet-search-hidden');
        if (emptyState) emptyState.hidden = matches > 0;
      } else {
        items.forEach((item) => {
          item.classList.remove('bt-facet-search-hidden');
          if (item.dataset.btCollapsed === 'true') item.classList.toggle('hidden', !this.wasExpanded);
        });
        showMore?.classList.remove('bt-facet-search-hidden');
        if (showMore) showMore.classList.toggle('hidden', this.wasExpanded);
        if (emptyState) emptyState.hidden = true;
      }

      this.lastQuery = query;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brincatoys-footer-design"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-bt-cookie-preferences]');
    if (!link || !window.privacyBanner?.showPreferences) return;
    event.preventDefault();
    try {
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => window.location.assign(link.href));
    } catch {
      window.location.assign(link.href);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brincatoys-legal-layout"] && !Shopify.designMode) return;
  try {
    (() => {
    const normaliseId = (value) => (value || '')
      .toLocaleLowerCase('pt-PT')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const initLegalDocument = (root) => {
      if (root.dataset.btLegalInitialised === 'true') return;
      root.dataset.btLegalInitialised = 'true';

      const content = root.querySelector('[data-bt-legal-content]');
      const toc = root.querySelector('[data-bt-legal-toc]');
      const list = root.querySelector('[data-bt-legal-toc-list]');
      if (!content || !toc || !list) return;

      const headings = [...content.querySelectorAll('h2, h3, h4')]
        .filter((heading) => heading.textContent.trim().length > 0 && !heading.closest('.shopify-policy__title'));
      if (headings.length < 2) return;

      const links = [];
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = `legal-${normaliseId(heading.textContent) || index + 1}`;
          let candidate = base;
          let suffix = 2;
          while (document.getElementById(candidate)) {
            candidate = `${base}-${suffix}`;
            suffix += 1;
          }
          heading.id = candidate;
        }

        const item = document.createElement('li');
        item.className = `bt-legal-toc__item bt-legal-toc__item--${heading.tagName.toLowerCase()}`;
        if (heading.tagName !== 'H2') item.classList.add('bt-legal-toc__item--nested');

        const link = document.createElement('a');
        link.className = 'bt-legal-toc__link';
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
        links.push({ heading, link });
      });

      toc.hidden = false;

      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (!visible) return;
        links.forEach(({ heading, link }) => {
          link.classList.toggle('is-active', heading === visible.target);
        });
      }, { rootMargin: '-18% 0px -70% 0px', threshold: 0 });

      links.forEach(({ heading }) => observer.observe(heading));
    };

    const alignCurrentLegalNavigation = (scope = document) => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      scope.querySelectorAll('.bt-legal-nav__list').forEach((navList) => {
        const activeLink = navList.querySelector('.bt-legal-nav__link[aria-current="page"]');
        if (!activeLink) return;

        const listRect = navList.getBoundingClientRect();
        const linkRect = activeLink.getBoundingClientRect();
        const styles = window.getComputedStyle(navList);
        const leftInset = navList.clientLeft + (parseFloat(styles.paddingLeft) || 0);
        const rightInset = navList.clientLeft + navList.clientWidth - (parseFloat(styles.paddingRight) || 0);
        const linkLeft = linkRect.left - listRect.left + navList.scrollLeft;
        const linkRight = linkLeft + linkRect.width;
        let target = navList.scrollLeft;

        if (linkLeft < target + leftInset) {
          target = linkLeft - leftInset;
        } else if (linkRight > target + rightInset) {
          target = linkRight - rightInset;
        }

        navList.scrollLeft = Math.max(0, Math.min(target, navList.scrollWidth - navList.clientWidth));
      });
    };

    let legalNavigationFrame = 0;
    window.addEventListener('resize', () => {
      if (legalNavigationFrame) window.cancelAnimationFrame(legalNavigationFrame);
      legalNavigationFrame = window.requestAnimationFrame(() => {
        legalNavigationFrame = 0;
        alignCurrentLegalNavigation();
      });
    }, { passive: true });

    const initAllLegalDocuments = (scope = document) => {
      alignCurrentLegalNavigation(scope);
      scope.querySelectorAll('[data-bt-legal-root]').forEach(initLegalDocument);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllLegalDocuments());
    } else {
      initAllLegalDocuments();
    }

    document.addEventListener('shopify:section:load', (event) => initAllLegalDocuments(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brincatoys-site-chrome"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawerSelector = '.bt-site-header .js-header-drawer-main';

    const resetDrawer = (details) => {
      details.querySelectorAll('.menu-drawer__navigation-container, .menu-drawer__navigation, .menu-drawer__inner-submenu').forEach((element) => {
        element.scrollTop = 0;
        element.scrollLeft = 0;
      });

      details.querySelectorAll('.js-header-drawer-sub[open]').forEach((submenu) => {
        submenu.removeAttribute('open');
        submenu.classList.remove('menu-opening');
        submenu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });

      details.querySelectorAll('.submenu-open').forEach((element) => element.classList.remove('submenu-open'));
    };

    const bindDrawers = (root = document) => {
      root.querySelectorAll(drawerSelector).forEach((details) => {
        if (details.dataset.btScrollResetBound === 'true') return;

        details.dataset.btScrollResetBound = 'true';
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          requestAnimationFrame(() => resetDrawer(details));
        });
      });
    };

    let predictiveFrame = 0;
    let observedPrivacyBanner;
    let privacyBannerObserver;
    const predictiveSearches = new WeakSet();

    const schedulePredictiveSpace = () => {
      if (!predictiveFrame) predictiveFrame = requestAnimationFrame(updatePredictiveSpace);
    };

    const observePrivacyBanner = () => {
      const banner = document.querySelector('#shopify-pc__banner');
      if (!banner || banner === observedPrivacyBanner || !('MutationObserver' in window)) return;

      privacyBannerObserver?.disconnect();
      observedPrivacyBanner = banner;
      privacyBannerObserver = new MutationObserver(schedulePredictiveSpace);
      privacyBannerObserver.observe(banner, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style']
      });
    };

    const updatePredictiveSpace = () => {
      predictiveFrame = 0;
      observePrivacyBanner();

      const panels = document.querySelectorAll('.bt-site-header .predictive-search--header, .bt-site-header .predictive-search--suggestions-desktop');
      if (!panels.length) return;

      const banner = document.querySelector('#shopify-pc__banner');
      const bannerStyle = banner && getComputedStyle(banner);
      const bannerBounds = banner?.getBoundingClientRect();
      const bannerVisible = bannerStyle?.display !== 'none' &&
        bannerStyle?.visibility !== 'hidden' && bannerBounds?.height > 0;

      const mobile = matchMedia('(max-width: 749.98px)').matches;
      const viewport = window.visualViewport;
      const viewportTop = `${Math.max(0, viewport?.offsetTop || 0)}px`;
      const dockedSearch = mobile && document.querySelector('.bt-site-header .header__search-bar > predictive-search:focus-within');
      const rootStyle = document.documentElement.style;
      const searchTop = dockedSearch ? viewportTop : '';
      if (rootStyle.getPropertyValue('--bt-search-viewport-top') !== searchTop) {
        if (searchTop) rootStyle.setProperty('--bt-search-viewport-top', searchTop);
        else rootStyle.removeProperty('--bt-search-viewport-top');
        // Measure on the next frame, after Safari has positioned the focused form.
        schedulePredictiveSpace();
        return;
      }
      const viewportBottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight);
      const bottomLimit = bannerVisible ? Math.min(viewportBottom, bannerBounds.top - 8) : viewportBottom;

      // Read every panel before changing styles: writing one height before
      // measuring the next panel forces an extra layout on mobile.
      const measurements = Array.from(panels, (panel) => {
        const panelStyle = getComputedStyle(panel);
        if (!mobile || panelStyle.display === 'none' || panelStyle.visibility === 'hidden') {
          return { panel, maxHeight: '' };
        }

        // Measure the visible panel itself: keyboard and Safari scrolling can move the header.
        const availableHeight = Math.max(0, Math.floor(bottomLimit - panel.getBoundingClientRect().top));
        return { panel, maxHeight: `${availableHeight}px` };
      });

      measurements.forEach(({ panel, maxHeight }) => {
        if ((panel.style.maxHeight || '') === maxHeight) return;
        if (maxHeight) panel.style.maxHeight = maxHeight;
        else panel.style.removeProperty('max-height');
      });
    };

    const bindPredictiveSearches = (root = document) => {
      root.querySelectorAll('.bt-site-header predictive-search').forEach((search) => {
        if (predictiveSearches.has(search)) return;
        predictiveSearches.add(search);
        if ('MutationObserver' in window) {
          new MutationObserver(schedulePredictiveSpace).observe(search, {
            attributes: true,
            attributeFilter: ['open', 'results', 'search-error']
          });
        }
      });
      schedulePredictiveSpace();
    };

    ['focusin', 'focusout', 'input'].forEach((type) => {
      document.addEventListener(type, (event) => {
        if (event.target.closest?.('.bt-site-header predictive-search')) schedulePredictiveSpace();
      }, true);
    });
    const scheduleWhileSearchOpen = () => {
      if (document.querySelector('.bt-site-header predictive-search[open], .bt-site-header predictive-search[results], .bt-site-header predictive-search[search-error], .bt-site-header predictive-search:focus-within')) schedulePredictiveSpace();
    };
    document.addEventListener('visitorConsentCollected', schedulePredictiveSpace);
    window.addEventListener('resize', schedulePredictiveSpace);
    window.addEventListener('scroll', scheduleWhileSearchOpen, { passive: true });
    window.visualViewport?.addEventListener('resize', scheduleWhileSearchOpen);
    window.visualViewport?.addEventListener('scroll', scheduleWhileSearchOpen, { passive: true });
    window.addEventListener('pagehide', () => privacyBannerObserver?.disconnect(), { once: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        bindDrawers();
        bindPredictiveSearches();
      }, { once: true });
    } else {
      bindDrawers();
      bindPredictiveSearches();
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindDrawers(event.target);
      bindPredictiveSearches(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
